import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Template } from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { useNavigate } from "react-router-dom";
import "./../../../App.css";
import moment from "moment";
import { reportService } from "../../../apis/apiServices/Report";

export default function ReportAssetMaterialMovementRequestComponent() {
  const navigate = useNavigate();
  const [
    assetMaterialMovementRequestDataSourceLst,
    setAssetMaterialMovementRequestDataSourceLst,
  ] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector(
      "#pageTitle"
    ).innerHTML = `Material Movement Request`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetMaterialMovementList(0);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetMaterialMovementList = async (materialMrId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetMaterialRequestReport(
        materialMrId
      );
      setAssetMaterialMovementRequestDataSourceLst(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="materialMrId"
              dataSource={assetMaterialMovementRequestDataSourceLst}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift({
                  location: "before",
                  template: "toolbarRefreshTemplate",
                });
              }}
            >
              <Column
                dataField="materialMrId"
                width={
                  assetMaterialMovementRequestDataSourceLst?.filter(
                    (f) =>
                      f.statusId ===
                      Number(AssetSubStatus.AssetMaterialMovementInDraftMode)
                  ).length > 0
                    ? 55
                    : 25
                }
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                cellRender={(cellData) => {
                  const idPrefix = `icon-${cellData?.data?.materialMrId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        <span>
                          <IconWithTooltip
                            id={`${idPrefix}-view`}
                            className="iconify-size mr-1"
                            title="View asset material movement request"
                            tooltip="View asset material movement request"
                            icon="solar:document-text-outline"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              navigate("/ViewMaterialMovementRequest", {
                                state: {
                                  materialMrId: cellData.data?.materialMrId,
                                  formId: cellData.data?.formId,
                                  stateData: cellData.data,
                                  isReport: true,
                                  sourceUrl: "ReportMaterialRequest",
                                },
                              });
                            }}
                          />
                        </span>
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="materialMovementNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="statusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#28A745";
                  if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementInDraftMode
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementBackToDraft
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementSentForApproval
                  )
                    color = "#FF9800";

                  return (
                    <div>
                      <span style={{ color }}>{e.data?.statusName}</span>
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentWorlFlowUserId > 0
                          ? e.data?.currentWorlFlowUserFullName
                          : e.data?.fromName}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="requestedDate"
                caption="Request Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format={DefaultDateFormat.GridDayMonthYearDateFormat}
              />
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromName || ""} ${
                    data?.fromDepartmentName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.fromName ?? ""}</span>
                      {data?.data?.fromDepartmentName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.fromDepartmentName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.toName || ""} ${
                    data?.toDepartmentName || ""
                  }`;
                }}
                allowSorting={true}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toName ?? ""}</span>
                      {data?.data?.toDepartmentName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toDepartmentName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toProjectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.toProjectName || ""} ${
                    data?.toLocationName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toProjectName ?? ""}</span>
                      {data?.data?.toLocationName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toLocationName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="noOfMaterials"
                caption="No Of Materials"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                alignment={"center"}
              />
              <Column
                dataField="createdDate"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.createdDate || ""} ${
                    data?.createdByName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.createdDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.createdDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.createdDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.createdByName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedByName"
                caption="Last Updated"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.updatedByName || ""} ${
                    data?.toDepartmentName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.updatedByName) {
                    return (
                      <>
                        <span>{data?.data?.updatedByName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartmentName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            await getAssetMaterialMovementList(0);
                          } catch (error) {
                            console.log(error);
                          }
                        }}
                      >
                        <i className="fas fa-sync-alt"></i>
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={10} />
              <Pager
                allowedPageSizes={[10, 15, 20, 50, 100]}
                showPageSizeSelector={true}
                showInfo={true}
                visible={true}
                showNavigationButtons={true}
              />
              <Export enabled={true} fileName="Material Movement Request" />
            </DataGrid>
          </div>
        </div>
      </div>
    </>
  );
}
